import {setVideo, playVideo} from '../module/video';

export default function loading() {

  /* Elements */
  let Wrapper = document.querySelectorAll('body')[0];
  let loading = document.getElementById('js-loading');
  let video = document.getElementById('js-video');
  let progress = document.getElementById('js-progress');

  /* Loading Timing */
  let timing = window.performance.timing;
  let edtimatedTime = -(timing.loadEventEnd - timing.navigationStart);
  let loadingTime = parseInt((edtimatedTime / 1000) % 60) * 100;

  /* Progress */
  let timer;
  let start = 0;
  let end = 100;
  let range = end - start;
  let steps = Math.abs(loadingTime / range);
  let current = start;

  /* ローディング処理 */
  function imageReady() {
    return new Promise(resolve => {
      timer = setInterval(() => {
        current += 1;
        progress.setAttribute('style', `width: ${current}%;`);
        if (current == end) {
          clearInterval(timer);
          resolve(true);
        }
      }, steps);
      // Loading画面時に付与
      Wrapper.classList.add('is-wrapper');
    })
  }

  /* Videoの実行 */
  function initVideo() {
    return new Promise((resolve, reject) => {
      if (video != null) {
        setVideo();
        resolve(true);
      } else {
        resolve(true);
      }
    });
  }

  /* init */
  Promise.all([
    initVideo(),
    imageReady()
  ]).then(results => {
    // Loading画面終了時に外す
    Wrapper.classList.remove('is-wrapper');
    // Loading画面終了時に付与
    loading.classList.add('is-close');
    if (video != null) {
      playVideo();
    }
  });

}